module.exports = __webpack_public_path__ + "media/images/common/project_off_left-194d3fae96a8e31df35fad75f5155f71.png";